/**
 * Serial request coalescing: only the most recently started request should apply results.
 */
export function createLatestRequestGate() {
  let latestRequestId = 0

  return {
    startRequest(): number {
      return ++latestRequestId
    },

    isLatestRequest(requestId: number): boolean {
      return requestId === latestRequestId
    }
  }
}
